module.exports = __webpack_public_path__ + "Utz_certified_logo.svg-6ced8f798e5fdf987ed375133122ba92.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/Utz_certified_logo.svg.png
// module id = 77
// module chunks = 0